<div [ngSwitch]="field.type">
  <ng-container *ngSwitchCase="'string'">
    <input
      *ngIf="!field.multiline"
      [id]="controlId"
      class="form-control"
      [value]="value || ''"
      (blur)="textValueChange.emit({ value: $event.target.value, fieldKey: field.key })"
      [title]="field.key"
      [attr.maxlength]="field.valueLength"
      [attr.aria-describedby]="describedById"
    />
    <textarea
      *ngIf="field.multiline"
      [id]="controlId"
      class="form-control"
      [value]="value || ''"
      (blur)="textValueChange.emit({ value: $event.target.value, fieldKey: field.key })"
      [title]="field.key"
      [attr.maxlength]="field.valueLength"
      [attr.aria-describedby]="describedById"
      rows="5"
    ></textarea>
  </ng-container>

  <input 
    *ngSwitchCase="'datetime'"
    [id]="controlId"
    class="form-control"
    type="date"
    [value]="StringAsDate(value) | date: 'yyyy-MM-dd'"
    (blur)="dateChange.emit({ value: $event.target.valueAsDate, fieldKey: field.key })"
    [title]="field.key"
    [attr.aria-describedby]="describedById" 
  />

  <input
    *ngSwitchCase="'int'"
    [id]="controlId"
    class="form-control"
    type="number"
    min="-2147483648"
    max="2147483647"
    [value]="value || ''"
    (blur)="intValueChange.emit({ value: $event.target.value, fieldKey: field.key })"
    [title]="field.key"
    [attr.aria-describedby]="describedById"
  />
<!-- (change)="validateNumber($event)" -->
  <app-range-field
    *ngSwitchCase="'range'"
    [field]="field"
    [minOperator]="optionValues[field.minOperatorKey]"
    [minValue]="optionValues[field.minValueKey]"
    [minUnit]="optionValues[field.minUnitKey]"
    [maxOperator]="optionValues[field.maxOperatorKey]"
    [maxValue]="optionValues[field.maxValueKey]"
    [maxUnit]="optionValues[field.maxUnitKey]"
    [description]="optionValues[field.descriptionKey]"
    [plausibility]="optionValues[field.plausibilityKey]"
    [stringValue]="optionValues[field.stringValueKey]"
    [stringValueLength]="253"
    [stringDescriptionLength]="253"
    [stringValueInputId]="controlId"
    [labelId]="labelId"
    (onRangeChanged)="rangeChanged.emit({ value: $event, fieldKey: field.key })"
  >
  </app-range-field>

  <input
    *ngSwitchCase="'double'"
    type="text"
    appNumericExpression
    [id]="controlId"
    class="form-control"
    [ngClass]="{ 'maximize-input': maximizeWidth }"
    [ngModel]="value"
    (ngModelChange)="doubleValueChange.emit({ value: $event, fieldKey: field.key })"
    [title]="field.key"
    [attr.aria-describedby]="describedById"
  />

  <ng-container *ngSwitchCase="'lookup'">
    <div [ngClass]="{ 'input-group': feedbackButtonIsVisible(field) }">
      <input 
        combobox
        [id]="controlId"
        class="form-control"
        [comboboxData]="field.options"
        [comboboxStrict]="true"
        [comboboxAutocomplete]="true"
        [comboboxMode]="'select'"
        type="text"
        [value]="value || ''"
        (blur)="dropdownValueChange.emit({ value: $event.target.value, fieldKey: field.key })"
        [title]="field.table"
        [aria-label]="field.table"
        [attr.aria-describedby]="describedById"
        [placeholder]="'components.searchField.placeholderAutocomplete' | translate"/>
      <div class="input-group-append" *ngIf="feedbackButtonIsVisible(field)">
        <button    
          type="button"
          class="btn btn-default btn-form-default"
          (click)="openFeedbackWindow(field.table, value, $event)"
          [title]="'components.lookup.actions.request' | translate"
          [attr.aria-label]="'components.lookup.actions.request' | translate"
          aria-haspopup="dialog"
        >
          <i class="fas fa-comment" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'ref'">
    <input 
      combobox
      [id]="controlId"
      class="form-control"
      [comboboxData]="loadItems"
      [comboboxOptionTemplate]="refOptionTemplate"
      type="text"
      [value]="value || ''"
      (blur)="dropdownValueChange.emit({ value: $event.target.value, fieldKey: field.key })"
      [title]="field.table"
      [aria-label]="field.table"
      [attr.aria-describedby]="describedById"
      [placeholder]="'components.searchField.placeholderAutocomplete' | translate" />
    <ng-template #refOptionTemplate let-item let-i="index">
      <i *ngIf="item.favorit" class="fa-star yellow fas" aria-hidden="true"></i>
      {{ item.objektId }} - 
      <strong>{{ item.name }}</strong>
    </ng-template>
  </ng-container>

  <ng-container *ngSwitchCase="'file'">
    <ng-container *ngTemplateOutlet="fileTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'image'">
    <ng-container *ngTemplateOutlet="fileTemplate"></ng-container>
  </ng-container>
  <ng-template #fileTemplate>
    <div class="input-group">
      <input 
        [id]="controlId" 
        class="form-control"
        type="text" 
        [value]="getFileName(value)" 
        readonly />
      <div class="input-group-append">
        <button
          type="button"
          class="btn btn-default btn-form-default"
          (click)="fileLinkChanged.emit({ value: null, fieldKey: field.key })"
          [title]="'action.clear' | translate"
          [attr.aria-label]="'action.clear' | translate"
        >
          <i class="fas fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </ng-template>
</div>
